import { IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
const ScrollWrapper = styled.div`
	overflow-y: scroll;
	background: ${({ expand }) =>
		expand ? 'rgba(255, 255, 255, 0.45)' : 'rgba(255, 255, 255, 0.25)'};
	cursor: pointer;
	border-radius: 4px;
`;

const Container = styled.div`
	width: 100%;
	padding: 6px;
`;

const Row = styled.div`
	width: 100$;
	display: flex;
	flex-direction: row;
	flex-flow: nowrap;
`;

const Column = styled.div`
	width: 100$;
	display: flex;
	flex-direction: column;
`;

const KeyTitle = styled.div`
	flex: ${({ column }) => column ? '0' : '1 1 0px'};
	width:${({ column }) => column ? '100' : '0'};
	padding: 4px;
	font-size: 9px;
	font-weight: 500;
	background: rgba(0, 0, 0, 0.05);
	text-transform: uppercase;
	border: 1px solid rgba(0, 0, 0, 0.08);
`;

const Value = styled.div`
    flex: ${({ column }) => column ? '0' : '1 1 0px'};
	width: ${({ column }) => column ? '100' : '0'};
	padding: 4px;
	font-size: 9px;
	border: 1px solid rgba(0, 0, 0, 0.08);
`;

const TitleWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 5px;
	padding: 6px 6px 6px 0;
	&:hover {
		background: rgba(0, 0, 0, 0.08);
	}
`;
const Title = styled.div`
	font-size: 0.8em;
	font-weight: 500;
`;

const ObjectView = ({ data }) => {
	const [formattedData, setFormattedData] = useState({});
	const [expand, setExpand] = useState(false);

	useEffect(() => {
		if (data) {
			const newData = { ...data };

			Object.keys(newData).forEach((key) => {
				if (newData[key] === null) {
					delete newData[key];
				}
			});
			setFormattedData(newData);
		}
	}, [data]);

	const renderValue = (value) => {
		if (typeof value === 'object') {
			return Object.keys(value).map((key) => (
				<Column>
					<KeyTitle column>{key}</KeyTitle>
					<Value column>{renderValue(value[key])}</Value>
				</Column>
			));
		}

		return String(value);
	};

	return (
        <>
		{formattedData && Object.keys(formattedData).length > 0 && <Container>
			<ScrollWrapper expand={expand}>
				<TitleWrapper onClick={() => setExpand(!expand)}>
					<IconButton size="small">
						<>
							{expand && <ExpandLess fontSize="0.7em" />}
							{!expand && <ExpandMore fontSize="0.7em" />}
						</>
					</IconButton>
					<Title>Expand Airasia Data</Title>
				</TitleWrapper>
				{expand &&
					formattedData &&
					Object.keys(formattedData).map((key) => (
						<>
							{formattedData[key] && (
								<Row>
									<KeyTitle>{key}</KeyTitle>
									<Value>{renderValue(formattedData[key])}</Value>
								</Row>
							)}
						</>
					))}
			</ScrollWrapper>
		</Container>}
        </>
	);
};

export default ObjectView;
